import type {ScanContext} from "../scan-model/ScanContext.tsx";
import type {VersionsScanPlan} from "./2-ScanVersions.tsx";
import type {ProjectId} from "../../../metl-models/id/ProjectId.tsx";
import type {ScannedSchedule} from "../scan-model/ScheduleScan.ts";

export async function scanSchedules(ctx: ScanContext, versionsToScan: VersionsScanPlan): Promise<ScannedSchedule[] | undefined> {
    const {api, log, logError, startAction, options} = ctx
    if(!options.analyseSchedules) return undefined
    const projectsToScan = versionsToScan.versions.map(x=>x.id as ProjectId).reduce((acc, val) => {
        if(!acc.some(x => x.groupName === val.groupName && x.projectName === val.projectName)) {
            acc.push({groupName: val.groupName, projectName: val.projectName})
        }
        return acc
    }, [] as ProjectId[])
    log(`Scanning schedules in ${projectsToScan.length} projects.`)
    const {reportOne, complete} = startAction("Scanning schedules", projectsToScan.length)
    let totalUnresolvedSchedules = 0
    const results = await Promise.all(projectsToScan.map(async (project) => {
        try {
            log(`Scanning schedules in ${project.groupName}/${project.projectName}`)
            const projectDebug = await api.project(project).debug()

            const schedulesDebug = Object.values(projectDebug.schedules ?? {})
            const schedulesExport = await api.project(project).schedule.exportAll()
            const scannedSchedules: (ScannedSchedule | undefined)[] = schedulesExport.objects.map(scheduleExport => {
                const debug = schedulesDebug.find(x => x.name === scheduleExport.name)
                if(!debug) {
                    totalUnresolvedSchedules++
                }
                return {
                    debug,
                    exported: scheduleExport,
                    projectId: project,
                    qid: debug?.qid ?? "Unknown"
                }
            })
            return scannedSchedules.filter(x=>x) as ScannedSchedule[]
        } catch(e) {
            logError(`An error occurred while scanning schedules in ${project.groupName}/${project.projectName}.`, e)
            return []
        } finally {
            reportOne()
        }
    }))
    if (totalUnresolvedSchedules > 0) {
        log(`${totalUnresolvedSchedules} schedule(s) did not have an internal METL id available, falling back to using starting job to link tasks to schedules.`)
    }
    log("Finished scanning schedules")
    complete()
    return results.flat()
}